import {
  completeSuccessIcon,
  completeUnsuccessfulIcon,
  businessEscalationIcon,
  followUpIcon,
  addtionalOutreachIcon,
  extensionGrantedIcon,
  Refresh2
} from "../../../../../assets/icons";

const MemberDisable = window["APP_SETTINGS"].DISABLEMEMBERS;

export const className = "edit-dropdown-menu";
export const firstGroupBtnOrder = [
  "Approve",
  "Decline",
  "Request Review",
  "Complete",
  "Cancel",
  "Archive",
  "Un-Archive",
];
export const secondGroupBtnOrder = MemberDisable === "TRUE" ? ["Reminder"] : ["Reminder", "Reassign", "ReOpen"];

export const buttonActionTextMapping = {
  Approve: "Approve Task",
  Decline: "Decline Task",
  Cancel: "Cancel Task",
  Complete: "Complete Task",
  Reminder: "Send Reminders",
  Reassign: "Re-Assign Task",
  "Request Review": "Request Review",
  ReOpen: "Re-open Task",
  Archive: "Archive",
  "Un-Archive": "Un-Archive",
};

export const buttonActionTextMappingWithLabel = (button, taskLabels) => {
  const label = taskLabels || "Task";
  const mapping = {
    Approve: `Approve ${label}`,
    Decline: `Decline ${label}`,
    Cancel: `Cancel ${label}`,
    Complete: `Complete ${label}`,
    Reminder: `Send Reminders`,
    Reassign: `Re-Assign ${label}`,
    "Request Review": `Request Review`,
    ReOpen: `Re-open ${label}`,
    Archive: `Archive ${label}`,
    "Un-Archive": `Un-Archive ${label}`,
  };
  return mapping[button];
}

export const iconMappings = [
  { keyword: "business escalation", icon: businessEscalationIcon },
  { keyword: "extension granted", icon: extensionGrantedIcon },
  { keyword: "completed - unsuccessfully", icon: completeUnsuccessfulIcon }, //needs to be before completed - successfully to don't pick up wrong icon
  { keyword: "quarantine", icon: completeUnsuccessfulIcon }, //needs to be before completed - successfully to don't pick up wrong icon
  { keyword: "completed - successfully", icon: completeSuccessIcon },
  { keyword: "outreach complete", icon: completeSuccessIcon },
  { keyword: "additional outreach required", icon: addtionalOutreachIcon },
  { keyword: "additional outreach started", icon: addtionalOutreachIcon },
  { keyword: "follow", icon: followUpIcon },
  { keyword: "approve", icon: completeSuccessIcon },
  { keyword: "decline", icon: completeUnsuccessfulIcon },
  { keyword: "undo", icon: Refresh2 },
];

export const popperConfig = { placement: "bottom-end" };
